import { Map } from 'immutable'
import { getAuthJwt } from 'services/auth'
import { RequestOptions, BaseApiResponse } from '../types'

export const makeAuthenticatedRequest = async <T extends BaseApiResponse>(
  url: string,
  auth: Map<string, string>,
  options: RequestOptions = {},
): Promise<T> => {
  const { method = 'POST', body, additionalHeaders = {}, timeout = 120000 } = options

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${getAuthJwt(auth)}`,
    ...additionalHeaders,
  }

  // Create an AbortController for timeout handling
  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), timeout)

  try {
    const response = await fetch(url, {
      method,
      headers,
      body: body ? JSON.stringify(body) : undefined,
      signal: controller.signal,
    })

    clearTimeout(timeoutId)

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    return response.json()
  } catch (error) {
    clearTimeout(timeoutId)

    // Check if this is a timeout/abort error
    if (error instanceof Error && error.name === 'AbortError') {
      throw new Error(`Request timed out after ${timeout / 1000} seconds. Please try again.`)
    }

    throw error
  }
}
